import React from 'react';
import { FormattedMessage } from "react-intl";
import './Nav.css';
import {Link} from "react-router-dom";

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
  }
  //Bestehend aus Gewichtsberechnung,
  //Interpolierte Dämpfung
  //Interpoliertes Eigenrauschen
  //Anzahl Kulissen
  //Preis
  //
  render() {

    return (
        <>
            <div className="grid-container">
              <Link className={"grid-item"} to={"/schalldaempfer"} >
                <img src="/kulissenschalldaempfer.jpg" alt="Kulissenschalldämpfer" />
                <br></br>
                <label className={"labels"}><FormattedMessage id="Berechnung_Schalldaempfer" /></label>
              </Link>
              <Link className={"grid-item"} to={"/kulisse"} >
                <img src="/kulissen.jpg" alt="Bild - Kulisse" />
                <br></br>
                <label className={"labels"}><FormattedMessage id="Berechnung_Kulissen" /></label>
              </Link>
            </div>
        </>
    );
  }
}
export default Navigation;
